import { Lock, Star, LogIn, DollarSign, Users, Shield } from 'lucide-react';
import { isGated } from '../utils/accessLabels';

const CONFIG = {
    password_protected:   { icon: Lock,      label: 'Password',    bg: 'bg-yellow-500/95',  text: 'text-white' },
    subscription_required:{ icon: Star,      label: 'Supporters',  bg: 'bg-purple-600/95',  text: 'text-white' },
    logged_in_required:   { icon: LogIn,     label: 'Login',       bg: 'bg-cyan-600/95',    text: 'text-white' },
    paid:                 { icon: DollarSign,label: 'Paid',        bg: 'bg-green-600/95',   text: 'text-white' },
    private:              { icon: Users,     label: 'Private',     bg: 'bg-blue-600/95',    text: 'text-white' },
    secret:               { icon: Shield,    label: 'Secret',      bg: 'bg-red-600/95',     text: 'text-white' },
};

// position: 'top-left' | 'top-right'
// iconOnly: true for tiny thumbnails where a text label won't fit
// isAuthenticated / hasActiveSubscription: when provided, badge hides if content is not actually gated for this user
const AccessLevelBadge = ({ accessLevel, position = 'top-left', iconOnly = false, isAuthenticated, hasActiveSubscription = false }) => {
    if (!accessLevel || accessLevel === 'public') return null;
    if (isAuthenticated !== undefined && !isGated(accessLevel, isAuthenticated, hasActiveSubscription)) return null;
    const c = CONFIG[accessLevel];
    if (!c) return null;
    const Icon = c.icon;

    const posClass = position === 'top-right' ? 'top-2 right-2' : 'top-2 left-2';

    if (iconOnly) {
        return (
            <div className={`absolute ${posClass} z-20 flex items-center justify-center w-5 h-5 rounded-full ${c.bg} ${c.text} shadow-lg`}>
                <Icon className="w-2.5 h-2.5" />
            </div>
        );
    }

    return (
        <div className={`absolute ${posClass} z-20 flex items-center gap-1 px-2 py-0.5 rounded-full ${c.bg} ${c.text} shadow-lg backdrop-blur-sm pointer-events-none`}>
            <Icon className="w-3 h-3 flex-shrink-0" />
            <span className="text-xs font-semibold leading-tight whitespace-nowrap">{c.label}</span>
        </div>
    );
};

export default AccessLevelBadge;
